export default __webpack_public_path__ + "static/media/red-marker-icon.10497740.png";